import React from "react";
import { Target, Eye } from "lucide-react";

function MissionVision() {
  return (
    <section id="mission-vision" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Mission & Vision</h2>
        </div>
        <div className="row g-4 justify-content-center">
          <div className="col-12 col-lg-6">
            <div className="mission-vision-card mission-card">
              <span className="quote-watermark" aria-hidden="true">“</span>
              <div className="mission-vision-icon-box mission-icon-box">
                <Target size={34} strokeWidth={2} />
              </div>
              <h3>Our Mission</h3>
              <p>
                To provide economic, effective and efficient services that will
                assist our members bridge the gap of acute and persistent
                financial deficit through the pool of resources that will be made
                available by cooperators and driven by cutting edge technology,
                sound management of financial and other resources with integrity
                and transparency, while making sure our management team and Staff
                are optimally motivated in order to add value and deliver quality
                services to the satisfaction of all stakeholders.
              </p>
            </div>
          </div>

          <div className="col-12 col-lg-6">
            <div className="mission-vision-card vision-card">
              <span className="quote-watermark" aria-hidden="true">“</span>
              <div className="mission-vision-icon-box vision-icon-box">
                <Eye size={34} strokeWidth={2} />
              </div>
              <h3>Our Vision</h3>
              <p>
                To be the largest and best Cooperative Society brand in Nigeria,
                providing unparalleled value to our members through innovative financial
                solutions, sustainable growth opportunities, and a commitment to
                excellence in all our endeavors.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MissionVision;
